import React from "react";
import { Link } from "react-router-dom";

import android from "../assets/img/brand-logos/android.png";
import angularjs from "../assets/img/brand-logos/angularjs.png";
import aws from "../assets/img/brand-logos/aws.png";
import azure from "../assets/img/brand-logos/azure.png";
import bigdata from "../assets/img/brand-logos/bigdata.png";
import blockchain from "../assets/img/brand-logos/blockchain.png";
import cpp from "../assets/img/brand-logos/c++.png";
import cHash from "../assets/img/brand-logos/chash.png";
import coigniter from "../assets/img/brand-logos/coeigniter.png";
import drupal from "../assets/img/brand-logos/drupal.png";
import electronjs from "../assets/img/brand-logos/electronjs.png";
import firebase from "../assets/img/brand-logos/firebase.png";
import flutter from "../assets/img/brand-logos/flutter.png";
import googleCloud from "../assets/img/brand-logos/googlecloud.png";
import hadoop from "../assets/img/brand-logos/hadoop.png";
import hybrid from "../assets/img/brand-logos/hybrid-app.png";
import iCloud from "../assets/img/brand-logos/icloud.png";
import ionic from "../assets/img/brand-logos/ionic.png";
import IOS from "../assets/img/brand-logos/IOS.png";
import java from "../assets/img/brand-logos/java.png";
import javascript from "../assets/img/brand-logos/javascript.png";
import joomla from "../assets/img/brand-logos/joomla.png";
import laravel from "../assets/img/brand-logos/laravel.png";
import machineLearning from "../assets/img/brand-logos/machinelearning.png";
import magento from "../assets/img/brand-logos/magento.png";
import native from "../assets/img/brand-logos/native-app.png";
import nodejs from "../assets/img/brand-logos/nodejs.png";
import objectivec from "../assets/img/brand-logos/objective-c.png";
import opencart from "../assets/img/brand-logos/opencart.png";
import phoneGap from "../assets/img/brand-logos/phone-gap.png";
import php from "../assets/img/brand-logos/php.png";
import powerbi from "../assets/img/brand-logos/powerbi.png";
import pwa from "../assets/img/brand-logos/pwa.png";
import python from "../assets/img/brand-logos/python.png";
import reactnative from "../assets/img/brand-logos/react-native.png";
import reactjs from "../assets/img/brand-logos/reactjs.png";
import ruby from "../assets/img/brand-logos/ruby.png";
import spagobi from "../assets/img/brand-logos/spagobi.png";
import swift from "../assets/img/brand-logos/swift.png";
import symfony from "../assets/img/brand-logos/symfony.png";
import tensorflow from "../assets/img/brand-logos/tensorflow.png";
import vuejs from "../assets/img/brand-logos/vuejs.png";
import wordpress from "../assets/img/brand-logos/wordpress.png";
import wpf from "../assets/img/brand-logos/wpf.png";
import xamarin from "../assets/img/brand-logos/xamarin.png";
import Navbar2 from "./Navbar2";

function Technologies() {
  return (
    <>
      <Navbar2 />
      {/* MAIN WRAPPER
    ================================================== */}
      <div className="main-wrapper">
        <div id="content" />
        {/* HEADER
  ================================================== */}
        {/* Header End */}
        {/* Hire Developer Section */}
        <section data-overlay-dark={9} data-background="" className="p-lg-5">
          <div className="container">
            <div className="row">
              {/* Left content column */}
              <div className=" col-12 mb-1-9 mb-lg-0">
                <div className="pe-lg-1-9">
                  <div className="row">
                    <div className="col-12">
                      <div className="section-heading white title-style5 left half">
                        <h2 className="text-uppercase h3 font-weight-600 text-wrap text-break">
                          Hire Software Developers / Programmers Of Shekru Labs
                          India Pvt. Ltd.
                        </h2>
                        <div className="square">
                          <span className="separator-left bg-primary" />
                          <span className="separator-right bg-primary" />
                        </div>
                        <p className="developers_description">
                          Shekru Labs India Pvt.Ltd. is a software development
                          firm offering software developers / engineers /
                          programmers to hire on hourly, part time or monthly
                          basis. We focus on creating scalable, high performing,
                          and secure software solutions for all the industry
                          verticals. We work closely with you to ensure a
                          successful engagement. Looking to hire programmers for
                          your software development? Hire dedicated software
                          developers of Solace Infotech on a flexible basis. Get
                          in touch now!
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
                <div>
                  <div className="row ">
                    {/* Each benefit column */}
                    <div className="col-lg-6 col-12 col-md-6 mb-3">
                      <div className="border-dotted p-2 text-white text-nowrap">
                        <i className="fa fa-check-circle text-white me-3 fs-4" />
                        Upto 60% Cost Saving
                      </div>
                    </div>
                    <div className="col-sm-6 col-12 mb-3">
                      <div className="border-dotted p-2 text-white text-nowrap">
                        <i className="fa fa-check-circle text-white me-3 fs-4" />
                        Source Code Authorization
                      </div>
                    </div>
                    <div className="col-sm-6 col-12 mb-3">
                      <div className="border-dotted p-2 text-white text-nowrap">
                        <i className="fa fa-check-circle text-white me-3 fs-4" />
                        Non-Disclosure Agreement
                      </div>
                    </div>
                    <div className="col-sm-6 col-12 mb-3">
                      <div className="border-dotted p-2 text-white text-nowrap">
                        <i className="fa fa-check-circle text-white me-3 fs-4" />
                        Experienced Coders
                      </div>
                    </div>
                    <div className="col-sm-6 col-12 mb-3">
                      <div className="border-dotted p-2 text-white text-nowrap">
                        <i className="fa fa-check-circle text-white me-3 fs-4" />
                        Lean processes, Agile mindset
                      </div>
                    </div>
                    <div className="col-sm-6 col-12 mb-3">
                      <div className="border-dotted p-2 text-white text-nowrap">
                        <i className="fa fa-check-circle text-white me-3 fs-4" />
                        Upto 2X less time
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              {/* Right form column */}
            </div>
          </div>
        </section>

        {/* Description Start */}
        <div className="container mt-6">
          <div className="row">
            <div className="col">
              <div className="text-center">
                <h2 className="m-4">
                  Overview Of Our Diverse Technology Competency
                </h2>
                <span className="">
                  Shekru Labs India is dedicated to offer technology solutions
                  for all industry verticals. We have a team of skilled
                  programmers experienced in diverse technology set ranging from
                  mobility, web development to Blockchain, AI, Ecommerce, CMS
                  and more. Take a look at the core technologies our developers
                  hold comprehensive expertise in.
                </span>
              </div>
            </div>
          </div>
        </div>
        {/* Description End */}
        {/* Technologies Start */}
        <div className="main ">
          <div className="container">
            {/* Mobility */}
            <h3 className="m-3">Mobility</h3>
            <div className="container mb-3 ">
              <div className="row">
                <div className="col-lg-2 col-md-4 my-2 d-sm-block">
                  <a
                    href="#"
                    className="d-block p-3 text-center border border-success rounded"
                  >
                    <img
                      src={android}
                      alt="Android"
                      className="me-2"
                      style={{ height: 24 }}
                    />
                    <span>Android</span>
                  </a>
                </div>
                <div className="col-lg-2 col-md-4 my-2 d-sm-block ">
                  <a
                    href="#"
                    className="d-block p-3 text-center border border-success rounded"
                  >
                    <img
                      src={IOS}
                      alt="IOS"
                      className="me-2"
                      style={{ height: 24 }}
                    />
                    <span>IOS</span>
                  </a>
                </div>
                <div className="col-lg-2 col-md-4 my-2 d-sm-block">
                  <a
                    href="#"
                    className="d-block p-3 text-center border border-success rounded"
                  >
                    <img
                      src={reactnative}
                      alt="react-native"
                      className="me-2"
                      style={{ height: 24 }}
                    />
                    <span>React Naive</span>
                  </a>
                </div>
                <div className="col-lg-2 col-md-4 my-2 d-sm-block">
                  <a
                    href="#"
                    className="d-block p-3 text-center border border-success rounded"
                  >
                    <img
                      src={flutter}
                      alt="flutter"
                      className="me-2"
                      style={{ height: 24 }}
                    />
                    <span>Flutter</span>
                  </a>
                </div>
                <div className="col-lg-2 col-md-4 my-2 d-sm-block">
                  <a
                    href="#"
                    className="d-block p-3 text-center border border-success rounded"
                  >
                    <img
                      src={ionic}
                      alt="ionic"
                      className="me-2"
                      style={{ height: 24 }}
                    />
                    <span>Ionic</span>
                  </a>
                </div>
                <div className="col-lg-2 col-md-4 my-2 d-sm-block">
                  <a
                    href="#"
                    className="d-block p-3 text-center border border-success rounded"
                  >
                    <img
                      src={xamarin}
                      alt="xamarin"
                      className="me-2"
                      style={{ height: 24 }}
                    />
                    <span>Xamarin</span>
                  </a>
                </div>
              </div>
            </div>
            <div className="container mb-7">
              <div className="row">
                <div className="col-lg-2 col-md-4 my-2 d-sm-block">
                  <a
                    href="#"
                    className="d-block p-3 text-center border border-success rounded"
                  >
                    <img
                      src={swift}
                      alt="swift"
                      className="me-2"
                      style={{ height: 24 }}
                    />
                    <span>Swift</span>
                  </a>
                </div>
                <div className="col-lg-2 col-md-4 my-2 d-sm-block">
                  <a
                    href="#"
                    className="d-block p-3 text-center border border-success rounded"
                  >
                    <img
                      src={hybrid}
                      alt="hybrid-app"
                      className="me-2"
                      style={{ height: 24 }}
                    />
                    <span>Hybrid App</span>
                  </a>
                </div>
                <div className="col-lg-2 col-md-4 my-2 d-sm-block">
                  <a
                    href="#"
                    className="d-block p-3 text-center border border-success rounded"
                  >
                    <img
                      src={pwa}
                      alt="pwa"
                      className="me-2"
                      style={{ height: 24 }}
                    />
                    <span>PWA</span>
                  </a>
                </div>
                <div className="col-lg-2 col-md-4 my-2 d-sm-block">
                  <a
                    href="#"
                    className="d-block p-3 text-center border border-success rounded"
                  >
                    <img
                      src={phoneGap}
                      alt="phone-gap"
                      className="me-2"
                      style={{ height: 24 }}
                    />
                    <span>PhoneGap</span>
                  </a>
                </div>
                <div className="col-lg-2 col-md-4 my-2 d-sm-block">
                  <a
                    href="#"
                    className="d-block p-3 text-center border border-success rounded"
                  >
                    <img
                      src={electronjs}
                      alt="electronjs"
                      className="me-2"
                      style={{ height: 24 }}
                    />
                    <span>Electron.js</span>
                  </a>
                </div>
                <div className="col-lg-2 col-md-4 my-2 d-sm-block">
                  <a
                    href="#"
                    className="d-block p-3 text-center border border-success rounded"
                  >
                    <img
                      src={native}
                      alt="native-app"
                      className="me-2"
                      style={{ height: 24 }}
                    />
                    <span>Native App</span>
                  </a>
                </div>
              </div>
            </div>
            {/* Js  & Frontend */}
            <h3 className="m-3">Js &amp; Frontend</h3>
            <div className="container mb-7">
              <div className="row">
                <div className="col-lg-2 col-md-4 my-2 d-sm-block">
                  <a
                    href="#"
                    className="d-block p-3 text-center border border-success rounded"
                  >
                    <img
                      src={javascript}
                      alt="javascript"
                      className="me-2"
                      style={{ height: 24 }}
                    />
                    <span>Javascript</span>
                  </a>
                </div>
                <div className="col-lg-2 col-md-4 my-2 d-sm-block">
                  <a
                    href="#"
                    className="d-block p-3 text-center border border-success rounded"
                  >
                    <img
                      src={angularjs}
                      alt="angularjs"
                      className="me-2"
                      style={{ height: 24 }}
                    />
                    <span>Angular</span>
                  </a>
                </div>
                <div className="col-lg-2 col-md-4 my-2 d-sm-block">
                  <a
                    href="#"
                    className="d-block p-3 text-center border border-success rounded"
                  >
                    <img
                      src={vuejs}
                      alt="vuejs"
                      className="me-2"
                      style={{ height: 24 }}
                    />
                    <span>Vue.js</span>
                  </a>
                </div>
                <div className="col-lg-2 col-md-4 my-2 d-sm-block">
                  <a
                    href="#"
                    className="d-block p-3 text-center border border-success rounded"
                  >
                    <img
                      src={reactjs}
                      alt="reactjs"
                      className="me-2"
                      style={{ height: 24 }}
                    />
                    <span>React.js</span>
                  </a>
                </div>
              </div>
            </div>
            {/* Big Data and Data analytics */}
            <h3 className="m-3">Big Data and Data analytics</h3>
            <div className="container mb-7">
              <div className="row">
                <div className="col-lg-2 col-md-4 my-2 d-sm-block">
                  <a
                    href="#"
                    className="d-block p-3 text-center border border-success rounded"
                  >
                    <img
                      src={hadoop}
                      alt="hadoop"
                      className="me-2"
                      style={{ height: 24 }}
                    />
                    <span>Hadoop</span>
                  </a>
                </div>
                <div className="col-lg-2 col-md-4 my-2 d-sm-block">
                  <a
                    href="#"
                    className="d-block p-3 text-center border border-success rounded"
                  >
                    <img
                      src={powerbi}
                      alt="powerbi"
                      className="me-2"
                      style={{ height: 24 }}
                    />
                    <span>Power BI</span>
                  </a>
                </div>
                <div className="col-lg-2 col-md-4 my-2 d-sm-block">
                  <a
                    href="#"
                    className="d-block p-3 text-center border border-success rounded"
                  >
                    <img
                      src={bigdata}
                      alt="bigdata"
                      className="me-2"
                      style={{ height: 24 }}
                    />
                    <span>Big Data</span>
                  </a>
                </div>
                <div className="col-lg-2 col-md-4 my-2 d-sm-block">
                  <a
                    href="#"
                    className="d-block p-3 text-center border border-success rounded"
                  >
                    <img
                      src={spagobi}
                      alt="spogibi"
                      className="me-2"
                      style={{ height: 24 }}
                    />
                    <span>SpagoBI</span>
                  </a>
                </div>
              </div>
            </div>
            {/* Cloud */}
            <h3 className="m-3">Cloud</h3>
            <div className="container mb-7">
              <div className="row">
                <div className="col-lg-2 col-md-4 my-2 d-sm-block">
                  <a
                    href="#"
                    className="d-block p-3 text-center border border-success  rounded"
                  >
                    <img
                      src={firebase}
                      alt="firebase"
                      className="me-2"
                      style={{ height: 24 }}
                    />
                    <span>Firebase</span>
                  </a>
                </div>
                <div className="col-lg-2 col-md-4 my-2 d-sm-block">
                  <a
                    href="#"
                    className="d-block p-3 text-center border border-success rounded"
                  >
                    <img
                      src={azure}
                      alt="azure"
                      className="me-2"
                      style={{ height: 24 }}
                    />
                    <span>Azure</span>
                  </a>
                </div>
                <div className="col-lg-2 col-md-4 my-2 d-sm-block">
                  <a
                    href="#"
                    className="d-block p-3 text-center border border-success rounded"
                  >
                    <img
                      src={aws}
                      alt="aws"
                      className="me-2"
                      style={{ height: 24 }}
                    />
                    <span>AWS</span>
                  </a>
                </div>
                <div className="col-lg-2  col-md-4 my-2 d-sm-block">
                  <a
                    href="#"
                    className="d-block p-3 text-center border border-success rounded"
                  >
                    <img
                      src={googleCloud}
                      alt="googleCloud"
                      className="me-2"
                      style={{ height: 24 }}
                    />
                    <span>Google</span>
                  </a>
                </div>
                <div className="col-lg-2 col-md-4 my-2 d-sm-block">
                  <a
                    href="#"
                    className="d-block p-3 text-center border border-success rounded"
                  >
                    <img
                      src={iCloud}
                      alt="iCloud"
                      className="me-2"
                      style={{ height: 24 }}
                    />
                    <span>iCloud</span>
                  </a>
                </div>
              </div>
            </div>
            {/* Backend */}
            <h3 className="m-3">Backend</h3>
            <div className="container mb-3">
              <div className="row">
                <div className="col-lg-2 col-md-4 my-2 d-sm-block">
                  <a
                    href="#"
                    className="d-block p-3 text-center border border-success rounded"
                  >
                    <img
                      src={php}
                      alt="php"
                      className="me-2"
                      style={{ height: 24 }}
                    />
                    <span>PHP</span>
                  </a>
                </div>
                <div className="col-lg-2 col-md-4 my-2 d-sm-block">
                  <a
                    href="#"
                    className="d-block p-3 text-center border border-success rounded"
                  >
                    <img
                      src={laravel}
                      alt="laravel"
                      className="me-2"
                      style={{ height: 24 }}
                    />
                    <span>Laravel</span>
                  </a>
                </div>
                <div className="col-lg-2 col-md-4 my-2 d-sm-block">
                  <a
                    href="#"
                    className="d-block p-3 text-center border border-success rounded"
                  >
                    <img
                      src={java}
                      alt="java"
                      className="me-2"
                      style={{ height: 24 }}
                    />
                    <span>Java</span>
                  </a>
                </div>
                <div className="col-lg-2 col-md-4 my-2 d-sm-block">
                  <a
                    href="#"
                    className="d-block p-3 text-center border border-success rounded"
                  >
                    <img
                      src={python}
                      alt="python"
                      className="me-2"
                      style={{ height: 24 }}
                    />
                    <span>Python</span>
                  </a>
                </div>
                <div className="col-lg-2 col-md-4 my-2 d-sm-block">
                  <a
                    href="#"
                    className="d-block p-3 text-center border border-success rounded"
                  >
                    <img
                      src={nodejs}
                      alt="nodejs"
                      className="me-2"
                      style={{ height: 24 }}
                    />
                    <span>Node.js</span>
                  </a>
                </div>
                <div className="col-lg-2 col-md-4 my-2 d-sm-block">
                  <a
                    href="#"
                    className="d-block p-3 text-center border border-success rounded"
                  >
                    <img
                      src={objectivec}
                      alt="objectiveC"
                      className="me-2"
                      style={{ height: 24 }}
                    />
                    <span>Objective C</span>
                  </a>
                </div>
              </div>
            </div>
            <div className="container mb-7">
              <div className="row">
                <div className="col-lg-2 col-md-4 my-2 d-sm-block">
                  <a
                    href="#"
                    className="d-block p-3 text-center border border-success rounded"
                  >
                    <img
                      src={cpp}
                      alt="cpp"
                      className="me-2"
                      style={{ height: 24 }}
                    />
                    <span>C++</span>
                  </a>
                </div>
                <div className="col-lg-2 col-md-4 my-2 d-sm-block">
                  <a
                    href="#"
                    className="d-block p-3 text-center border border-success rounded"
                  >
                    <img
                      src={cHash}
                      alt="cHash"
                      className="me-2"
                      style={{ height: 24 }}
                    />
                    <span>C#</span>
                  </a>
                </div>
                <div className="col-lg-2 col-md-4 my-2 d-sm-block">
                  <a
                    href="#"
                    className="d-block p-3 text-center border border-success rounded"
                  >
                    <img
                      src={ruby}
                      alt="ruby"
                      className="me-2"
                      style={{ height: 24 }}
                    />
                    <span>Ruby</span>
                  </a>
                </div>
                <div className="col-lg-2 col-md-4 my-2 d-sm-block">
                  <a
                    href="#"
                    className="d-block p-3 text-center border border-success rounded"
                  >
                    <img
                      src={coigniter}
                      alt="coigniter"
                      className="me-2"
                      style={{ height: 24 }}
                    />
                    <span>Coeigniter</span>
                  </a>
                </div>
                <div className="col-lg-2 col-md-4 my-2 d-sm-block">
                  <a
                    href="#"
                    className="d-block p-3 text-center border border-success rounded"
                  >
                    <img
                      src={symfony}
                      alt="symfony"
                      className="me-2"
                      style={{ height: 24 }}
                    />
                    <span>Symfony</span>
                  </a>
                </div>
                <div className="col-lg-2 col-md-4 my-2 d-sm-block">
                  <a
                    href="#"
                    className="d-block p-3 text-center border border-success rounded"
                  >
                    <img
                      src={wpf}
                      alt="wpf"
                      className="me-2"
                      style={{ height: 24 }}
                    />
                    <span>WPF</span>
                  </a>
                </div>
              </div>
            </div>
            {/* Blockchain ML & AI */}
            <h3 className="m-3">Blockchain ML &amp; AI</h3>
            <div className="container mb-7">
              <div className="row">
                <div className="col-lg-2 col-md-4 my-2 d-sm-block">
                  <a
                    href="#"
                    className="d-block p-3 text-center border border-success rounded"
                  >
                    <img
                      src={blockchain}
                      alt="blockchian"
                      className="me-2"
                      style={{ height: 25 }}
                    />
                    <span>Blockchain</span>
                  </a>
                </div>
                <div className="col-lg-3 col-md-4 my-2 d-sm-block">
                  <a
                    href="#"
                    className="d-block p-3 text-center border border-success rounded"
                  >
                    <img
                      src={machineLearning}
                      alt="machineLearning"
                      className="me-2"
                      style={{ height: 24 }}
                    />
                    <span>Machine Learning</span>
                  </a>
                </div>
                <div className="col-lg-2 col-md-4 my-2 d-sm-block">
                  <a
                    href="#"
                    className="d-block p-3 text-center border border-success rounded"
                  >
                    <img
                      src={tensorflow}
                      alt="tensorflow"
                      className="me-2"
                      style={{ height: 24 }}
                    />
                    <span>Tensorflow</span>
                  </a>
                </div>
              </div>
            </div>
            {/* E-Commerce and CMS  */}
            <h3 className="m-3">E-Commerce and CMS</h3>
            <div className="container mb-7">
              <div className="row">
                <div className="col-lg-2 col-md-4 my-2 d-sm-block">
                  <a
                    href="#"
                    className="d-block p-3 text-center border border-success rounded"
                  >
                    <img
                      src={drupal}
                      alt="drupal"
                      className="me-2"
                      style={{ height: 24 }}
                    />
                    <span>Drupal</span>
                  </a>
                </div>
                <div className="col-lg-2 col-md-4 my-2 d-sm-block">
                  <a
                    href="#"
                    className="d-block p-3 text-center border border-success rounded"
                  >
                    <img
                      src={magento}
                      alt="magento"
                      className="me-2"
                      style={{ height: 24 }}
                    />
                    <span>Magento</span>
                  </a>
                </div>
                <div className="col-lg-2 col-md-4 my-2 d-sm-block">
                  <a
                    href="#"
                    className="d-block p-3 text-center border border-success rounded"
                  >
                    <img
                      src={wordpress}
                      alt="wordpress"
                      className="me-2"
                      style={{ height: 24 }}
                    />
                    <span>Wordpress</span>
                  </a>
                </div>
                <div className="col-lg-2 col-md-4 my-2 d-sm-block">
                  <a
                    href="#"
                    className="d-block p-3 text-center border border-success rounded"
                  >
                    <img
                      src={opencart}
                      alt="opencart"
                      className="me-2"
                      style={{ height: 22 }}
                    />
                    <span>Opencart</span>
                  </a>
                </div>
                <div className="col-lg-2 col-md-4 my-2 d-sm-block">
                  <a
                    href="#"
                    className="d-block p-3 text-center border border-success rounded"
                  >
                    <img
                      src={joomla}
                      alt="joomla"
                      className="me-2"
                      style={{ height: 24 }}
                    />
                    <span>Joomla</span>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* Technologies End */}
        {/* Hiring Models Start */}
        <div className="container mb-5 mt-8">
          <div className="row">
            <div className="col">
              <h2 className="text-center">
                Choose From A Variety Of Hiring Models
              </h2>
              <div className="text-center mt-4">
                We provide the flexibility of choosing the best suited
                engagement model to all our clients.
              </div>
            </div>
          </div>
        </div>
        <div className="container ">
          <div className="row   justify-content-center">
            <div
              className="col-md-6 col-xl-3 mb-3 wow fadeIn "
              data-wow-delay="100ms"
            >
              <div className="card card-style3 border-1 shadow-none">
                <div className="card-body d-flex justify-content-center align-items-center p-2">
                  <i className="fa-solid fa-users me-3" />
                  <h4 className="display-27 mb-0">Dedicated Team</h4>
                </div>
              </div>
            </div>
            <div
              className="col-md-6 col-xl-3 mb-3 wow fadeIn"
              data-wow-delay="100ms"
            >
              <div className="card card-style3 border-1 shadow-none">
                <div className="card-body d-flex justify-content-center align-items-center p-2">
                  <i className="fa-regular fa-money-bill-1 me-3" />
                  <h4 className="display-27 mb-0">Fixed Price Model</h4>
                </div>
              </div>
            </div>
            <div
              className="col-md-6 col-xl-3 mb-3  wow fadeIn"
              data-wow-delay="100ms"
            >
              <div className="card card-style3 border-1 shadow-none">
                <div className="card-body d-flex justify-content-center align-items-center p-2">
                  <i className="fa-solid fa-clock me-3" />
                  <h4 className="display-27 mb-0">Hourly</h4>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="text-center my-4 mb-5">
          Large &amp; fast paced projects / No hidden costs / Guaranteed 160
          monthly hours / Easy payment methods / Milestone based payment
        </div>
        <div className="row mt-n1-9 mx-0">
          <div className="col-md-6 col-lg-4 mb-4 d-flex align-items-center">
            <div className="price-table-style3 border border-secondary text-center h-100 d-flex flex-column justify-content-between p-lg-3 ">
              <div className="price-table-content">
                <div className="mb-4">
                  <span className="d-inline-block text-black rounded-circle p-lg-2">
                    1
                  </span>
                </div>
                <h5 className="mb-4">Team Screening &amp; Selection</h5>
                <ul className="text-start mb-sm-0">
                  <li>
                    Our developer's skills &amp; your requisites are matched.
                  </li>
                  <li>
                    You interview the developers and hire them as per your
                    project needs.
                  </li>
                  <li>
                    You choose the desired engagement model &amp; sign NDAs.
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <div className="col-md-6 col-lg-4 mb-4">
            <div className="price-table-style3 border border-secondary text-center h-100 d-flex flex-column justify-content-between p-lg-3 ">
              <div className="price-table-content">
                <div className="mb-4">
                  <span className="d-inline-block text-black rounded-circle p-lg-2">
                    2
                  </span>
                </div>
                <h5 className="mb-4">Development &amp; Reporting</h5>
                <ul className="text-start mb-sm-0">
                  <li>You interact with team and plan for milestones.</li>
                  <li>Get daily status updates as per sprint.</li>
                  <li>Skype, email, and calls are our communication tools.</li>
                </ul>
              </div>
            </div>
          </div>
          <div className="col-md-6 col-lg-4 mb-4 ">
            <div className="price-table-style3 border border-secondary text-center h-100 d-flex flex-column justify-content-between p-lg-3">
              <div className="price-table-content">
                <div className="mb-4">
                  <span className="d-inline-block text-black rounded-circle p-lg-2">
                    3
                  </span>
                </div>
                <h5 className="mb-4">Delivery &amp; Team Extension</h5>
                <ul className="text-start mb-sm-0">
                  <li>
                    We follow agile methodologies &amp; deliver sprint-wise.
                  </li>
                  <li>Our development team produces First-Time-Right codes.</li>
                  <li>Team size can be scaled up or down if required.</li>
                </ul>
              </div>
            </div>
          </div>
        </div>

        {/* Why hire Developers Start */}
        <section
          data-overlay-dark={9}
          data-background=""
          className="p-lg-5 text-white"
        >
          <div className="container">
            <div className="row">
              <h2 className="text-center mb-3 text-white">
                Why Hire Developers from Shekru Labs?
              </h2>
              <div className="text-center mb-3">
                At Shekru Labs, we offer reliable software development services
                that guarantee faster turnaround times and superior ROI. When
                you hire our developers, you gain access to a team of
                well-trained experts dedicated to delivering innovative,
                best-in-class results. As a leading software development
                company, we ensure that our services are tailored to meet your
                unique requirements, providing customized solutions that drive
                your business forward.
              </div>
              <div className="container mt-1 mb-4">
                <div className="text-center position-relative">
                  <hr className="bg-success mx-0" />
                  <div className="d-flex flex-wrap justify-content-center align-items-center">
                    <div className="d-flex align-items-center mx-3 my-2">
                      <i className="fa-regular fa-money-bill-1 me-lg-4 me-3 d-none d-lg-block d-md-block" />
                      <span className="fs-lg-4 fs-5 ">60% Cost Saving</span>
                    </div>
                    <div className="d-flex align-items-center mx-3 my-2">
                      <i className="fas fa-thumbs-up fa-lg me-lg-4 me-3  d-none d-lg-block d-md-block" />
                      <span className="fs-lg-4 fs-5">No Hidden Costs</span>
                    </div>
                    <div className="d-flex flex-row align-items-center mx-3 my-1">
                      <i className="fas fa-user fa-lg me-lg-3 me-2   d-none d-lg-block d-md-block" />
                      <span className="fs-lg-4 fs-5">
                        Guaranteed 160 Monthly Hours
                      </span>
                    </div>
                  </div>
                  <hr className="bg-success mx-0" />
                </div>
              </div>
            </div>
          </div>
          <div className="container mt-4">
            <div className="row text-center justify-content-center">
              {/* First Row */}
              <div className="col-11 col-md-7 col-lg-3 border-dotted rounded px-3 mx-lg-4 my-3">
                <div className="mb-3">
                  <i
                    className="fa-solid fa-life-ring text-success py-4"
                    style={{ fontSize: "2rem" }}
                  />
                </div>
                <h5 className="mb-3 text-white">
                  Integrity &amp; transparency
                </h5>
                <hr className="bg-success" />
                <p>
                  Your idea is safe with us as we respect your secrecy, work
                  transparently, and our developers follow.
                </p>
              </div>
              <div className="col-11 col-md-7 col-lg-3 border-dotted rounded px-3 mx-lg-4 my-3">
                <div className="mb-3">
                  <i
                    className="fa-solid fa-briefcase text-success py-2"
                    style={{ fontSize: "2rem" }}
                  />
                </div>
                <h5 className="mb-3 text-white">
                  3+ Years of average experience
                </h5>
                <hr className="bg-success " />
                <p>
                  Our developers are experienced &amp; well-versed with the
                  perks of development.
                </p>
              </div>
              <div className="col-11 col-md-7 col-lg-3 border-dotted rounded px-3 mx-lg-4 my-3">
                <div className="mb-3">
                  <i
                    className="fa-solid fa-handshake text-success py-3"
                    style={{ fontSize: "2rem" }}
                  />
                </div>
                <h5 className="mb-3 text-white">Free no obligation quote</h5>
                <hr className="bg-success" />
                <p>
                  When you share your idea, we listen &amp; provide you with a
                  no-cost estimate, usually within 24 working hours.
                </p>
              </div>
            </div>
            {/* Second Row */}
            <div className="row text-center justify-content-center mt-4 mb-5">
              <div className="col-11 col-md-7 col-lg-3 border-dotted rounded px-3 mx-lg-4 my-3">
                <div className="mb-3">
                  <i
                    className="fa-solid fa-database text-success py-4"
                    style={{ fontSize: "2rem" }}
                  />
                </div>
                <h5 className="mb-3 text-white">Your local guy costs more</h5>
                <hr className="bg-success" />
                <p>
                  We provide the perfect balance of competitive pricing &amp;
                  uncompromising quality.
                </p>
              </div>
              <div className="col-11 col-md-7 col-lg-3 border-dotted rounded px-3 mx-lg-4 my-3">
                <div className="mb-3">
                  <i
                    className="fa-solid fa-thumbs-up text-success py-2"
                    style={{ fontSize: "2rem" }}
                  />
                </div>
                <h5 className="mb-3 text-white">
                  Implemented more than 4200 projects
                </h5>
                <hr className="bg-success" />
                <p>
                  We have successfully completed hundreds of projects and are
                  ready to explore new ventures.
                </p>
              </div>
              <div className="col-11 col-md-7 col-lg-3 border-dotted rounded px-3 mx-lg-4 my-3">
                <div className="mb-3">
                  <i
                    className="fa-solid fa-users text-success py-3"
                    style={{ fontSize: "2rem" }}
                  />
                </div>
                <h5 className="mb-3 text-white">Free project management</h5>
                <hr className="bg-success" />
                <p>
                  We not only build fast but also free you from management
                  issues. You get a PM from our side.
                </p>
              </div>
            </div>
           
          </div>
        </section>
        {/* Why hire Developers End */}
       
      </div>
    </>
  );
}

export default Technologies;
